import styled from 'styled-components';

import PrimitiveModal from '../../../../../../newComponents/Modal';

export const Container = styled.div`
  font-family: 'Sora', sans-serif;
`;

export const ComplementItemsList = styled.div`
  padding: 20px 32px 0px 32px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 285.26px);
  overflow: auto;

  > button {
    svg {
      margin-right: 10px;
    }
  }
`;

export const ComplementItem = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #e6effb;
  border-radius: 5px;
  padding: 20px;
  background-color: #ffffff;
  margin-bottom: 20px;
`;

export const ComplementItemContent = styled.div`
  display: flex;
  gap: 20px;

  div.horizontal,
  div.vertical,
  div.left {
    display: flex;
    gap: 20px;
  }

  div.left {
    width: 153px;
    min-width: 153px;
  }

  div.left > div:last-child {
    width: 100%;
  }

  div.vertical,
  div.left {
    flex-direction: column;
  }

  div.vertical,
  div.min-max {
    flex: 1;
  }

  div.min-max {
    > div {
      width: 100%;
    }
  }

  @media (max-width: 560px) {
    flex-direction: column;

    div.left {
      width: 100%;
    }

    div.horizontal {
      flex-direction: column;
    }

    div.min-max {
      flex-direction: row;
    }
  }
`;

export const FileInputContainer = styled.div`
  width: 153px;
  height: 92px;

  @media (max-width: 560px) {
    width: 100%;
    height: 50vw;
  }

  > div {
    &:first-child {
      height: 100%;
    }
  }
`;

export const DeleteButton = styled.button`
  flex: 1;
  margin-left: 44px;
  background-color: rgba(246, 68, 68, 0.1);
  color: rgb(246, 68, 68);
  padding: 11px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  margin-top: 20px;

  &:hover {
    background-color: rgba(246, 68, 68, 0.3);
  }
`;

export const Modal = styled(PrimitiveModal)`
  position: relative;
  padding: 36px 40px;
  border-radius: 8px;
  max-width: 500px;
  font-family: 'Sora', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p {
    text-align: center;
    margin-top: 10px;
    font-family: 'Sora', sans-serif;
    font-size: 17px;
    color: #7c8db5;
    margin-bottom: 24px;

    strong {
      color: #101d40;
      font-weight: 600;
      margin-top: 5px;
    }
  }

  button {
    & + button {
      margin-top: 15px;
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(246, 68, 68, 0.2);
    margin: none;

    svg {
      color: #f64444;
      font-size: 50px;
    }
  }

  h1 {
    color: #101d40;
    font-size: 26px;
    text-align: center;
    font-weight: 800;
    margin-top: 15px;
    font-family: 'Sora', sans-serif;
  }

  button {
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: rgba(215, 222, 233, 0.25);

    svg {
      color: #4f4f4f;
      font-size: 22px;
    }

    &:hover {
      background-color: rgba(215, 222, 233, 0.5);
    }
  }
`;
